/**
 * Returns the correct <img src> for a bubble's artwork.
 * Prefers the static URL (post-migration) over inline base64 (legacy).
 * Returns null if neither is available — caller renders a gradient fallback.
 *
 * Accepts any object that may have image_url / image_b64 / bubble_image_b64 /
 * cover_image_b64 / cover_image_url / display_image_b64 / display_image_url.
 */
export function bubbleImageSrc(obj) {
  if (!obj) return null;
  const base = process.env.REACT_APP_BACKEND_URL || '';
  const urlField =
    obj.image_url ||
    obj.cover_image_url ||
    obj.display_image_url ||
    obj.bubble_image_url ||
    obj.art_url ||
    null;
  if (urlField) {
    if (urlField.startsWith('http')) return urlField;
    return `${base}${urlField}`;
  }
  const b64Field =
    obj.image_b64 ||
    obj.cover_image_b64 ||
    obj.display_image_b64 ||
    obj.bubble_image_b64 ||
    null;
  if (b64Field) return `data:image/png;base64,${b64Field}`;
  return null;
}

/**
 * Returns a media URL for cargo (audio / image / clip) attached to a bubble.
 * Cargo always lives on disk: cargo.media_url is "/api/static/cargo/...".
 */
export function cargoMediaSrc(cargo) {
  if (!cargo?.media_url) return null;
  if (cargo.media_url.startsWith('http')) return cargo.media_url;
  const base = process.env.REACT_APP_BACKEND_URL || '';
  return `${base}${cargo.media_url}`;
}

/**
 * Resolves any backend-served URL (audio mp3, mp4, png) to an absolute URL.
 * Pass paths that start with "/api/static/..." or "/places/photo?..." and
 * we'll prepend REACT_APP_BACKEND_URL (no extra /api).
 */
export function backendUrl(path) {
  if (!path) return null;
  if (path.startsWith('http')) return path;
  const base = process.env.REACT_APP_BACKEND_URL || '';
  return `${base}${path}`;
}

